/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

import { useAppDispatch } from 'redux/hooks'
import { setAlertMessages, setAlertTime, setAlertType } from 'redux/ui/common/alertUI'

export const useSuccessAlert = (messages: string, time = 6000) => {
  const dispatch = useAppDispatch()

  const handleSuccess = (messages: string) => {
    dispatch(setAlertMessages(messages))
    dispatch(setAlertType('success'))
    dispatch(setAlertTime(time))
  }

  useEffect(() => {
    messages && handleSuccess(messages)
  }, [messages])
}
